import './public-path';
import React from 'react';
import { hydrateRoot } from "react-dom";
import App from './App';
import { Provider } from 'react-redux';
import {persistor, store} from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { isVzgptEnabled, resolveIframeId } from './shared/utils/iframeBridge';

const vzgptEnabled = isVzgptEnabled(window.vzgpt);
const iframeId = resolveIframeId(window.iframeId);

hydrateRoot(
  document.getElementById('app'),
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App vzgptEnabled={vzgptEnabled} iframeId={iframeId} />
      </PersistGate>
    </Provider>
);
